/**
 * Подвал главной: логотип, контакты (якорь `#contacts` для меню) и ссылки по сайту.
 */
import "./landing.css";
import { Link } from "react-router-dom";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

const CONTACT_EMAIL = "ilya.ermoshin123@gmail.com";
const COPYRIGHT_YEAR = 2026;

const SOCIAL_LINKS = [
	{ label: "Instagram", href: "https://www.instagram.com/grid_planner_global/", icon: "instagram" },
	{ label: "Telegram", href: "https://t.me/gridplanner", icon: "telegram" },
	{ label: "YouTube", href: "https://www.youtube.com/@grid-planner-global", icon: "youtube" },
] as const;

const SocialIcon = ({ icon }: { icon: (typeof SOCIAL_LINKS)[number]["icon"] }) => (
	<svg viewBox="0 0 24 24" className="size-5" fill="none" aria-hidden="true">
		{icon === "instagram" ? (
			<>
				<rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" />
				<circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
				<circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
			</>
		) : icon === "telegram" ? (
			<path
				d="m20.7 4.2-3 15c-.2 1-1 1.2-1.8.7l-4.8-3.5-2.3 2.2c-.3.3-.5.5-1 .5l.4-4.9L17.1 6c.4-.4-.1-.6-.6-.3L5.6 12.5.9 11c-1-.3-1-1 .2-1.5l18.4-7c.9-.3 1.6.2 1.2 1.7Z"
				fill="currentColor"
			/>
		) : (
			<>
				<rect x="2" y="5" width="20" height="14" rx="4" fill="currentColor" />
				<path d="m10 9 5 3-5 3V9Z" fill="currentColor" className="text-landing-night" />
			</>
		)}
	</svg>
);

export const LandingFooter = () => (
	<footer id="contacts" className="border-t border-border bg-landing-night text-landing-muted">
		<div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-8 md:grid-cols-landing-footer">
			<div>
				<div className="flex flex-col leading-none text-landing-text">
					<UIKit.Text as="span" className="text-lg font-black tracking-label">
						GRID
					</UIKit.Text>
					<UIKit.Text as="span" className="text-base font-light tracking-display">
						PLANNER
					</UIKit.Text>
				</div>
				<UIKit.Text className="mt-5 max-w-85 text-sm leading-copy-relaxed">
					Онлайн-планировщик ремонта любых помещений: чертёж, развёртки стен с электрикой и 3D-вид.
				</UIKit.Text>
			</div>
			<nav aria-label="Разделы сайта">
				<UIKit.Text as="span" className="lp-mono block text-xs text-landing-muted">
					Разделы
				</UIKit.Text>
				<ul className="mt-4 grid gap-2 text-sm">
					<li>
						<Link className="hover:text-landing-text" to={routerPaths.planner}>
							Планировщик
						</Link>
					</li>
					<li>
						<a className="hover:text-landing-text" href="#how">
							Как это работает
						</a>
					</li>
					<li>
						<a className="hover:text-landing-text" href="#features">
							Возможности
						</a>
					</li>
				</ul>
			</nav>
			<div>
				<UIKit.Text as="span" className="lp-mono block text-xs text-landing-muted">
					Контакты
				</UIKit.Text>
				<UIKit.Text className="mt-4 text-sm leading-copy-relaxed">
					Продукт в разработке. Нашли ошибку или хотите функцию - напишите, мы читаем всё.
				</UIKit.Text>
				<a
					className="mt-2 inline-block text-sm text-landing-text hover:text-landing-accent"
					href={`mailto:${CONTACT_EMAIL}`}
				>
					{CONTACT_EMAIL}
				</a>
				<nav className="mt-5 flex gap-2" aria-label="Социальные сети">
					{SOCIAL_LINKS.map((social) => (
						<a
							key={social.label}
							className="flex size-9 items-center justify-center rounded-md border border-border text-landing-text transition-colors hover:border-landing-accent hover:bg-landing-button-hover hover:text-landing-accent"
							href={social.href}
							target="_blank"
							rel="noreferrer"
							aria-label={social.label}
						>
							<SocialIcon icon={social.icon} />
						</a>
					))}
				</nav>
			</div>
		</div>
		<div className="border-t border-border">
			<div className="lp-mono mx-auto flex max-w-7xl flex-col gap-1 px-4 py-5 text-xs text-landing-muted sm:flex-row sm:justify-between sm:px-8">
				<UIKit.Text>© {COPYRIGHT_YEAR} GRID PLANNER</UIKit.Text>
				<UIKit.Text>ИП Ермошин Илья Александрович ИНН 165039821104</UIKit.Text>
			</div>
		</div>
	</footer>
);
